export const LoaderSize = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
} as const;

export type LoaderSizeType = (typeof LoaderSize)[keyof typeof LoaderSize];

export type LoaderProps = {
  id?: string;
  testId?: string;
  ariaLabel?: string;
  size?: LoaderSizeType;
  announced?: boolean;
};

export type LoaderContainerProps = LoaderProps & {
  minWrapper?: boolean;
};
